import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSupplier } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useDeleteSupplier = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteSupplierMutate, isPending } = useMutation({
        mutationFn: deleteSupplier,
        onSuccess: (res) => {
            toast.success(res.message || "Supplier deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to delete supplier");
        },
    });

    return { deleteSupplierMutate, isPending };
};

export default useDeleteSupplier;
